/* Publish by EComposer at 2025-08-07 20:15:13*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sesyhmenp87"]=  window.__ectimmers["ecom-sesyhmenp87"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-sesyhmenp87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sesyhmenp87', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yr2pd8oiq7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yr2pd8oiq7f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c51zwa1x1ne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c51zwa1x1ne', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7w1f72rtci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7w1f72rtci', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rmzwcih8qb"]=  window.__ectimmers["ecom-rmzwcih8qb"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-rmzwcih8qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rmzwcih8qb', settings: {"content_type":"html"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-38qpeax74co"]=  window.__ectimmers["ecom-38qpeax74co"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var r=s.getAttribute("href")||"#",a=r.replace("{current-link}",location.href);s.setAttribute("href",a)})}

                    });
                    
                        document.querySelectorAll('.ecom-38qpeax74co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38qpeax74co', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-aq7ykmukh6l"]=  window.__ectimmers["ecom-aq7ykmukh6l"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t=this.isLive,o="bullets";if(this.settings.slider_pagination_style==="progress"&&(o="progressbar"),!i)return;let s=i.querySelector(".ecom-shopify__blog-container"),a=s&&s.dataset.optionSwiper;a=JSON.parse(a),a.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:o,clickable:!0},a.allowTouchMove=t,a.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(s,a)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const n=this.dataset.get,l=this.closest(".ecom-sections[data-section-id]");if(!n||!l||!l.dataset.sectionId)return;const c=l.dataset.sectionId,_=`${n}&section_id=${c}`;a(_,l),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const a=function(e,n){const l=async function(c){return(await fetch(c,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};n.classList.add("ecom-doing-load-blog"),l(e).then(function(c){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=c;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=n.querySelector(".ecom-shopify__blog--posts"),$=n.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){n.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-aq7ykmukh6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aq7ykmukh6l', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}